import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_IAP } from '@/modules/iap/router';
import { iapService } from '@/services/iap';
import { useMixins } from './mixins';

export default function () {
    const router = useAppRouter();

    const { v$, model, features } = useMixins();

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () =>
            iapService.create(model.name, model.feature, model.packageId, model.priceId, model.price, model.credit),
        onSuccess: () => router.push({ name: ROUTE_NAME_IAP.INDEX })
    });
    return { v$, model, features, create };
}
